import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import {get, getErrorMessage, PATH_USERS_LOGOUT} from "../../../common/backend";
import {toast} from "react-hot-toast";
import {useLoader} from "../../../common/Loader";

const LogoutDialog = ({open, user, close}) => {
    user = user || {}

    const {setLoading} = useLoader()

    const logout = () => {
        setLoading(true)
        get(PATH_USERS_LOGOUT + user.id, res => {
            toast.success('Done')
            close()
        }, res => toast.error(getErrorMessage(res))).finally(() => setLoading(false))
    }

    return <Dialog open={open} onClose={close}>
        <DialogTitle>Logout user {user.email} from all devices?</DialogTitle>
        <DialogActions>
            <Button onClick={close}>No</Button>
            <Button onClick={logout}>Yes</Button>
        </DialogActions>
    </Dialog>
}
export default LogoutDialog